import React, { useState } from "react";
import "./AdminDashboard.css";
import CourtForm from "./component/CourtForm.js";
import AdminDashboardApprove from "./AdminDashboardApprove.js";
import CrudView from "./dashboard/CrudView.js";

function AdminDashboard() {
  const [activeTab, setActiveTab] = useState("overview"); // default to 'overview'

  return (
    <div className="form_page">
      <div className="form">
        <div className="admin-tabs">
          <button
            className={`tab-button ${activeTab === "overview" ? "active" : ""}`}
            onClick={() => setActiveTab("overview")}
          >
            Overview
          </button>
          <button
            className={`tab-button ${activeTab === "add" ? "active" : ""}`}
            onClick={() => setActiveTab("add")}
          >
            Add New Court
          </button>
          <button
            className={`tab-button ${activeTab === "approve" ? "active" : ""}`}
            onClick={() => setActiveTab("approve")}
          >
            Approve Courts
          </button>
        </div>

        {activeTab === "overview" && (
          <>
            <h1>Dashboard Overview</h1>
            <p className="form_body">
              Welcome to the admin dashboard. Here you can view, add, update and delete existing venues.
            </p>
            <CrudView></CrudView>
          </>
        )}

        {activeTab === "add" && (
          <>
            <h1>Add a new court</h1>
            <p className="form_body">
              Fill in the below form and we'll review it ASAP!
            </p>
            <CourtForm />
          </>
        )}

        {activeTab === "approve" && (
          <>
            <h1>Approve Submitted Courts</h1>
            <p className="form_body">
              Review and approve courts submitted by users
            </p>
            <AdminDashboardApprove />
          </>
        )}
      </div>
    </div>
  );
}

export default AdminDashboard;
